<figure class="logo {{classCustom}}">   
  <img [src]="logo" alt="Logo" [width]="widthLogo" />   
</figure>

  